export const queryKeys = {
  auth: {
    profile: () => ['auth', 'profile'] as const,
  },
  estimates: {
    all: ['estimates'] as const,
    list: (teamId: string | number) => ['estimates', 'list', String(teamId)] as const,
    detail: (estimateId: string | number) => ['estimates', 'detail', String(estimateId)] as const,
  },
  teams: {
    all: ['teams'] as const,
    list: () => ['teams', 'list'] as const,
    detail: (teamId: string | number) => ['teams', 'detail', String(teamId)] as const,
    dealerships: (teamId: string | number) => ['teams', 'dealerships', String(teamId)] as const,
    connectedBodyshop: (dealershipId: string | number) => ['teams', 'connected-bodyshop', String(dealershipId)] as const,
    connectedDealerships: (bodyshopId: string | number) => ['teams', 'connected-dealerships', String(bodyshopId)] as const,
    members: (teamId: string | number) => ['teams', 'members', String(teamId)] as const,
  },
  invites: {
    all: ['invites'] as const,
    byTeam: (teamId: string | number) => ['invites', 'team', String(teamId)] as const,
    byUuid: (uuid: string) => ['invites', 'uuid', uuid] as const,
  },
  salesLeads: {
    all: ['salesLeads'] as const,
    list: (teamId: string | number, page: number) => ['salesLeads', 'list', String(teamId), page] as const,
    pending: (teamId: string | number) => ['salesLeads', 'pending', String(teamId)] as const,
    assigned: (teamId: string | number) => ['salesLeads', 'assigned', String(teamId)] as const,
    detail: (teamId: string | number, leadId: string | number) =>
      ['salesLeads', 'detail', String(teamId), String(leadId)] as const,
    search: (teamId: string | number, term: string) =>
      ['salesLeads', 'search', String(teamId), term] as const,
  },
  payouts: {
    all: ['payouts'] as const,
    list: (teamId: string | number) => ['payouts', 'list', String(teamId)] as const,
  },
  activity: {
    all: ['activity'] as const,
    list: (teamId: string | number) => ['activity', 'list', String(teamId)] as const,
  },
  tasks: {
    all: ['tasks'] as const,
    list: (teamId: string | number) => ['tasks', 'list', String(teamId)] as const,
    byEstimate: (estimateId: string | number) =>
      ['tasks', 'estimate', String(estimateId)] as const,
  },
  customerActivity: {
    all: ['customerActivity'] as const,
    byCustomer: (customerId: string | number) =>
      ['customerActivity', 'customer', String(customerId)] as const,
  },
  referrals: {
    all: ['referrals'] as const,
    byAdvisor: (userId: number | string) =>
      ['referrals', 'advisor', String(userId)] as const,
  },
  campaigns: {
    all: ['campaigns'] as const,
    results: (teamId: string | number) =>
      ['campaigns', 'results', String(teamId)] as const,
    inbox: (teamId: string | number) =>
      ['campaigns', 'inbox', String(teamId)] as const,
    analytics: (teamId: string | number) =>
      ['campaigns', 'analytics', String(teamId)] as const,
  },
  appointments: {
    all: ['appointments'] as const,
    byTeam: (teamId: string | number, from: string, to: string) =>
      ['appointments', 'team', String(teamId), from, to] as const,
    slots: (teamId: string | number, from: string, to: string) =>
      ['appointments', 'slots', String(teamId), from, to] as const,
    booking: (token: string) => ['appointments', 'booking', token] as const,
    bookingSlots: (token: string, from: string, to: string) =>
      ['appointments', 'booking', token, 'slots', from, to] as const,
  },
  reporting: {
    all: ['reporting'] as const,
    // Date params are part of the key so each window has its own cache slot.
    // null/null means "all time" — same key shape regardless so a switch back
    // to all-time hits the cache.
    estimates: (
      teamId: string | number,
      startDate: string | null,
      endDate: string | null,
    ) => ['reporting', 'estimates', String(teamId), startDate, endDate] as const,
  },
}
